import commonConstant from '../../common/_commonConstant';

export const getProfile = (state, action) => {
  switch (action.type) {
    case commonConstant.GET_PROFILE_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.GET_PROFILE_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const updateProfile = (state, action) => {
  switch (action.type) {
    case commonConstant.UPDATE_PROFILE_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.UPDATE_PROFILE_FAILURE:
      return Object.assign({}, state, { ...action });
    default:
      return state ? state : {};
  }
};
